module.exports = `${require.publicPath}logo.47d12a3e.png`;